module.exports = __webpack_public_path__ + "img/mem_coupon_font4_m.60fab85e.jpg";